// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.hardwareOverviewTooltip__O8joF {
  min-width: 200px;
  min-height: 132px;
  padding: 8px !important;
  opacity: 1 !important;
  filter: drop-shadow(0 0 1px rgba(12, 26, 75, 0.24));
  border-radius: 4px !important;
  text-align: left !important;
}

.hardwareOverviewTooltipInfo__aOYrK {
  color: #f2f2f2;
}

.infoHead__eiS6u {
  font-size: 12px;
  line-height: 18px;
  padding-top: 4px;
  padding-bottom: 4px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.infoTotal__KoemZ {
  text-transform: uppercase;
}

.infoItem__d5Nan {
  font-size: 11px;
  font-weight: 500;
  line-height: 12px;
  padding: 8px;
  border-top: 1px solid var(--tables-primary-row-stroke);
}
.infoItem__d5Nan:not(:last-child) {
  padding-bottom: 8px;
}
.infoItem__d5Nan div {
  padding: 2px 8px;
}
.infoItem__d5Nan span {
  color: #a8acb7;
}

.infoItemCritical__vtDyB {
  border-left: 3px solid var(--labels-filled-surface-critical);
}

.infoItemHigh__CiUHu {
  border-left: 3px solid var(--labels-filled-surface-high);
}

.infoItemStandard__qlDsm {
  border-left: 3px solid var(--labels-filled-surface-standard);
}`, "",{"version":3,"sources":["webpack://./../src/pages/HardwareOverview/components/TooltipHardwareOverview/style.module.scss"],"names":[],"mappings":"AA0EA;EACE,gBAAA;EACA,iBAAA;EAlBA,uBAAA;EACA,qBAAA;EACA,mDAAA;EACA,6BAAA;EACA,2BAAA;AAtDF;;AAyEA;EACE,cAAA;AAtEF;;AAyEA;EACE,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,mBAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;AAtEF;;AAyEA;EACE,yBAAA;AAtEF;;AAyEA;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,YAAA;EACA,sDAAA;AAtEF;AAwEE;EACE,mBAAA;AAtEJ;AAyEE;EACE,gBAAA;AAvEJ;AA0EE;EACE,cAAA;AAxEJ;;AA4EA;EACE,4DAAA;AAzEF;;AA4EA;EACE,wDAAA;AAzEF;;AA4EA;EACE,4DAAA;AAzEF","sourcesContent":["%scrollbar-style {\n  scrollbar-color: rgba(0, 0, 0, 0.2) rgba(0, 0, 0, 0.05);\n  scrollbar-width: auto;\n\n  &::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: #888;\n    border-radius: 3px;\n  }\n}\n@mixin scrollBar {\n  &::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: #888;\n    border-radius: 3px;\n  }\n}\n\n@mixin ellipsis-text {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: pre-wrap;\n  word-wrap: break-word;\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n}\n\n@mixin tooltip {\n  padding: 8px !important;\n  opacity: 1 !important;\n  filter: drop-shadow(0 0 1px rgba(12, 26, 75, 0.24));\n  border-radius: 4px !important;\n  text-align: left !important;\n}\n\n@mixin modalTitle {\n  color: var(--header-title-main);\n  font-size: 18px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 20px;\n  text-transform: uppercase;\n}\n\n.hardwareOverviewTooltip {\n  min-width: 200px;\n  min-height: 132px;\n\n  @include tooltip;\n}\n\n.hardwareOverviewTooltipInfo {\n  color: #f2f2f2;\n}\n\n.infoHead {\n  font-size: 12px;\n  line-height: 18px;\n  padding-top: 4px;\n  padding-bottom: 4px;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.infoTotal {\n  text-transform: uppercase;\n}\n\n.infoItem {\n  font-size: 11px;\n  font-weight: 500;\n  line-height: 12px;\n  padding: 8px;\n  border-top: 1px solid var(--tables-primary-row-stroke);\n\n  &:not(:last-child) {\n    padding-bottom: 8px;\n  }\n\n  div {\n    padding: 2px 8px;\n  }\n\n  span {\n    color: #a8acb7;\n  }\n}\n\n.infoItemCritical {\n  border-left: 3px solid var(--labels-filled-surface-critical);\n}\n\n.infoItemHigh {\n  border-left: 3px solid var(--labels-filled-surface-high);\n}\n\n.infoItemStandard {\n  border-left: 3px solid var(--labels-filled-surface-standard);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"hardwareOverviewTooltip": `hardwareOverviewTooltip__O8joF`,
	"hardwareOverviewTooltipInfo": `hardwareOverviewTooltipInfo__aOYrK`,
	"infoHead": `infoHead__eiS6u`,
	"infoTotal": `infoTotal__KoemZ`,
	"infoItem": `infoItem__d5Nan`,
	"infoItemCritical": `infoItemCritical__vtDyB`,
	"infoItemHigh": `infoItemHigh__CiUHu`,
	"infoItemStandard": `infoItemStandard__qlDsm`
};
module.exports = ___CSS_LOADER_EXPORT___;
